<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add Module</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            <v-select item-value='Course_Id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                                <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Course_Title }}
                                  </template>
                                  <template slot='item' slot-scope='{ item }'>
                                        {{ item.Course_Title }}    
                                  </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Module Title" v-model="Section_Title"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" @click="SubmitSection">Submit Module</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : {},
            Section_Title           : "",
        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        CloseDialog(){

            this.$emit('close')
            this.ClearForm()
        },
        SubmitSection(){

            let Section = {}
            Section["Course_Id"]      = this.SelectedCourseDetail['_id']
            Section["Section_Title"]  = this.Section_Title

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/addsection`,Section)
                        .then(response =>{
                            
                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Section","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                           this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Section","Color":"red","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedCourseDetail    = {}
            this.Section_Title           = ""
            
        },
        GetCourseDetailsList(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
    }
}
</script>
<style scoped>

</style>